var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7710_66735)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7710_66735)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.898 75.8119V99.9973H42.7744V75.8119C38.7946 76.2911 35.1164 74.032 34.7045 69.8718C35.83 61.1315 30.3531 42.8887 43.873 41.9409C47.1984 41.7066 56.8004 41.5235 59.7058 42.2505C63.6344 43.2334 66.6475 46.8658 66.9679 50.9128C67.4768 57.3348 66.7821 64.7639 66.7013 71.2209C65.6 74.6782 62.3742 76.1834 58.898 75.8119Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7502 70.9759C9.77045 71.4552 6.09228 69.196 5.6803 65.0359C6.80583 56.2955 1.32896 38.0527 14.8488 37.1049C18.597 36.841 25.8779 36.736 29.5157 37.1695C31.2013 37.3715 33.1131 38.2574 34.4137 39.3264C34.7799 39.6252 36.6674 41.3782 36.1989 41.7659C33.3258 44.1381 31.721 47.1297 31.476 50.9102C31.1017 56.6698 31.2929 64.0396 31.476 69.8773C31.4868 70.265 31.6322 70.6016 31.6887 70.9732H29.8765V95.1614H13.7502V70.9759Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9222 70.9757V95.1611H71.7986V70.9757H69.9864C70.0403 70.6014 70.1857 70.2648 70.1991 69.8771C70.3822 64.0394 70.5734 56.6696 70.1991 50.91C69.9702 47.3826 68.2119 43.7179 65.3389 41.6365C66.4052 39.6304 68.6401 38.0471 70.8373 37.4601C73.6565 36.7062 83.7755 36.8489 87.0255 37.1074C91.7296 37.479 95.6205 41.3564 95.9948 46.0766C96.5037 52.4986 95.809 59.9277 95.7282 66.3847C94.6269 69.8421 91.4011 71.3473 87.9249 70.9757H87.9222Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6836 0.0833843C48.4909 -1.33834 51.916 15.7412 40.6634 18.9805C27.2539 22.8391 23.3011 1.69629 36.6836 0.0833843Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4821 0.0833843C74.2894 -1.33834 77.7144 15.7412 66.4618 18.9805C53.0524 22.8391 49.1022 1.69629 62.4821 0.0833843Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.56 16.2098C32.3673 14.7881 35.7923 31.8677 24.5397 35.1069C11.1276 38.9655 7.17744 17.8228 20.56 16.2098Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.6083 16.2098C90.4156 14.7881 93.8407 31.8677 82.5881 35.1069C69.1759 38.9655 65.2258 17.8228 78.6083 16.2098Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5841 21.0458C61.3914 19.6241 64.8165 36.7036 53.5639 39.9429C40.1517 43.8015 36.2016 22.6587 49.5841 21.0458Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7710_66735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7710_66735"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90.678,
    height: 100,
    fill: "white",
    transform: "translate(5.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.cd7793344ba69a401ab2ee0e3696452b.svg";
export { ForwardRef as ReactComponent };